import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';

export default class FirebaseRoute extends Route {
  @service declare errorTracking: Services['error-tracking'];
  @service declare firebaseService: Services['firebase-service'];

  async beforeModel(): Promise<void> {
    try {
      await this.firebaseService.initialize();
    } catch (error) {
      this.errorTracking.captureException(error);
    }
  }
}
